/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContactDetailRequest } from './ContactDetailRequest';
import {
    ContactDetailRequestFromJSON,
    ContactDetailRequestFromJSONTyped,
    ContactDetailRequestToJSON,
    ContactDetailRequestToJSONTyped,
} from './ContactDetailRequest';

/**
 * 
 * @export
 * @interface CreateClientRequest
 */
export interface CreateClientRequest {
    /**
     * 
     * @type {Date}
     * @memberof CreateClientRequest
     */
    initialRegistrationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    contactSource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    salutation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    formerLastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    country: string;
    /**
     * 
     * @type {Array<ContactDetailRequest>}
     * @memberof CreateClientRequest
     */
    contactDetails?: Array<ContactDetailRequest>;
    /**
     * 
     * @type {Date}
     * @memberof CreateClientRequest
     */
    birthday?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    insuranceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    employmentStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    qualification?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    placeOfBirth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    nationality?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    maritalStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientRequest
     */
    livingSituation?: string | null;
}

/**
 * Check if a given object implements the CreateClientRequest interface.
 */
export function instanceOfCreateClientRequest(value: object): value is CreateClientRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function CreateClientRequestFromJSON(json: any): CreateClientRequest {
    return CreateClientRequestFromJSONTyped(json, false);
}

export function CreateClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'initialRegistrationDate': json['initialRegistrationDate'] == null ? undefined : (new Date(json['initialRegistrationDate'])),
        'contactSource': json['contactSource'] == null ? undefined : json['contactSource'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'salutation': json['salutation'] == null ? undefined : json['salutation'],
        'title': json['title'] == null ? undefined : json['title'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'formerLastName': json['formerLastName'] == null ? undefined : json['formerLastName'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'contactDetails': json['contactDetails'] == null ? undefined : ((json['contactDetails'] as Array<any>).map(ContactDetailRequestFromJSON)),
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
        'insuranceNumber': json['insuranceNumber'] == null ? undefined : json['insuranceNumber'],
        'employmentStatus': json['employmentStatus'] == null ? undefined : json['employmentStatus'],
        'qualification': json['qualification'] == null ? undefined : json['qualification'],
        'placeOfBirth': json['placeOfBirth'] == null ? undefined : json['placeOfBirth'],
        'nationality': json['nationality'] == null ? undefined : json['nationality'],
        'maritalStatus': json['maritalStatus'] == null ? undefined : json['maritalStatus'],
        'livingSituation': json['livingSituation'] == null ? undefined : json['livingSituation'],
    };
}

export function CreateClientRequestToJSON(json: any): CreateClientRequest {
    return CreateClientRequestToJSONTyped(json, false);
}

export function CreateClientRequestToJSONTyped(value?: CreateClientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initialRegistrationDate': value['initialRegistrationDate'] == null ? value['initialRegistrationDate'] : `${value['initialRegistrationDate'].getFullYear()}-${String(value['initialRegistrationDate'].getMonth()+1).padStart(2,'0')}-${String(value['initialRegistrationDate'].getDate()).padStart(2,'0')}`,
        'contactSource': value['contactSource'],
        'comment': value['comment'],
        'salutation': value['salutation'],
        'title': value['title'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'formerLastName': value['formerLastName'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'contactDetails': value['contactDetails'] == null ? undefined : ((value['contactDetails'] as Array<any>).map(ContactDetailRequestToJSON)),
        'birthday': value['birthday'] == null ? value['birthday'] : `${value['birthday'].getFullYear()}-${String(value['birthday'].getMonth()+1).padStart(2,'0')}-${String(value['birthday'].getDate()).padStart(2,'0')}`,
        'insuranceNumber': value['insuranceNumber'],
        'employmentStatus': value['employmentStatus'],
        'qualification': value['qualification'],
        'placeOfBirth': value['placeOfBirth'],
        'nationality': value['nationality'],
        'maritalStatus': value['maritalStatus'],
        'livingSituation': value['livingSituation'],
    };
}

